var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "a9fdf57ad06fe6236d19c3f85f04b5728ccccf03"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["disivo@disivo-sro"] = {
  id: "a9fdf57ad06fe6236d19c3f85f04b5728ccccf03"
};